// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* copy rught */

.MuiButton-outlined.MuiButton-outlinedPrimary {
  font-family: var(--roboto-font), sans-serif !important;
}

.MuiButton-contained.MuiButton-containedPrimary {
  font-family: var(--roboto-font), sans-serif !important;
}

.MuiButton-root {
  font-family: var(--roboto-font), sans-serif !important;
}
.StageTwoButtonComponentMainSection
  .dPSButtonComponentSection.MuiButton-contained.MuiButton-containedPrimary {
  background-color: #3276cf;
  color: aliceblue;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/button/DpsButtonSummarisation.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;AACxD;AACA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":["/* copy rught */\n\n.MuiButton-outlined.MuiButton-outlinedPrimary {\n  font-family: var(--roboto-font), sans-serif !important;\n}\n\n.MuiButton-contained.MuiButton-containedPrimary {\n  font-family: var(--roboto-font), sans-serif !important;\n}\n\n.MuiButton-root {\n  font-family: var(--roboto-font), sans-serif !important;\n}\n.StageTwoButtonComponentMainSection\n  .dPSButtonComponentSection.MuiButton-contained.MuiButton-containedPrimary {\n  background-color: #3276cf;\n  color: aliceblue;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
